import { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import Swal from "sweetalert2";
import constant from "../js/constant";
import { ApiGetMethod, ApiPostMethod } from "../js/helper";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import "./contact.css";
import { FiRefreshCw } from "react-icons/fi";
import contactimg from "../../image/contactform11.png"

const ContactUs = () => {
  const formData = new FormData();
  const [contactFormData, setContactFormData] = useState({
    name: "",
    email: "",
    number: "",
    subject: "",
    message: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setContactFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBlur = (event) => {
    const { name } = event.target;
    const errors = validateField(name);
    setFormErrors((prevState) => ({
      ...prevState,
      [name]: errors[name],
    }));
    if (!errors[name]) {
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(contactFormData).forEach((key) => {
      const fieldErrors = validateField(key);
      if (fieldErrors[key]) {
        errors[key] = fieldErrors[key];
      }
    });
    return errors;
  };

  const validateField = (name) => {
    const errors = {};
    const value = contactFormData[name];
    switch (name) {
      case "name":
        if (!value) {
          errors[name] = "Please enter your name";
        }
        break;
      case "email":
        if (!value) {
          errors[name] = "Please enter your email";
        } else if (!/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/.test(value)) {
          errors[name] = "Please enter a valid email address";
        }
        break;
      case "number":
        if (!value) {
          errors[name] = "Please enter your phone number";
        } else if (!/^\d{10}$/.test(value)) {
          errors[name] = "Please enter a valid 10-digit phone number";
        }
        break;
      case "subject":
        if (!value) {
          errors[name] = "Please enter a subject";
        }
        break;
      case "message":
        if (!value) {
          errors[name] = "Please enter a message";
        }
        break;
      default:
        break;
    }
    return errors;
  };

  const captchaRef1 = useRef(null);
  const [captcha, setCaptcha] = useState();
  const [errorcaptcha, setErrorCaptcha] = useState();

  const handlecaptcha = (event) => {
    setCaptcha(event.target.value);
  };

  const handleCaptcha1 = (e) => {
    const captcha = captchaRef1.current.value;
    // setCaptcha(captchaRef1.current.value)
    if (validateCaptcha(captcha)) {
      //   alert("true");
      setErrorCaptcha("");
    } else {
      //   alert("false");
      setErrorCaptcha("Enter the correct captcha");
    }
  };
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length === 0 && validateCaptcha(captcha)) {
      formData.append("name", contactFormData.name);
      formData.append("number", contactFormData.number);
      formData.append("email", contactFormData.email);
      formData.append("subject", contactFormData.subject);
      formData.append("message", contactFormData.message);
      let data = formData;
      let url = `${constant.baseurl}contactUs`;
      ApiPostMethod(url, data).then((response) => {
        if (response.error == false) {
          Swal.fire({
            title: "Success!",
            text: response.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          setContactFormData({
            name: "",
            email: "",
            number: "",
            subject: "",
            message: "",
          });
          setCaptcha("");
          loadCaptchaEnginge(6);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      });
    }
  };
  const [websiteLinks, setWebsiteLinks] = useState({});

  useEffect(() => {
    let data = formData;
    let url = `${constant.baseurl}settings`;
    ApiGetMethod(url, data).then((response) => {
      if (response.error == false) {
        setWebsiteLinks(response.data);
      } else {
      }
    });
  }, []);

  return (
    <>
      <Container fluid className="contact_top background-grey  top_class">
        <Col lg="12" className="contacthead">
          <p>Contact Us</p>
        </Col>
        <Container>
          <Col lg="12" className="contact-details">
            <div className="contact_details col-12 mb-5">
              <div className="headImage text-center w-100">
                {/* <svg
                  viewBox="0 0 447 224"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1204_6087)">
                    <path
                      d="M147.154 224C133.671 224 120.208 223.759 106.765 223.276C87.5574 222.586 67.6951 221.873 49.2339 211.634C36.3195 204.472 24.8818 192.981 16.1577 178.403C10.3266 168.522 6.05097 157.802 3.48102 146.621C-1.31292 126.263 -1.14964 105.052 3.95715 84.7699C5.74677 77.8162 8.21388 71.0547 11.3231 64.5824C24.7861 36.7033 49.3416 17.9887 78.6936 13.2378C78.936 13.2064 79.1811 13.2011 79.4246 13.2222C79.5566 13.2293 79.6882 13.2368 79.8223 13.2312L79.995 13.1763C80.4377 13.0225 80.8925 12.9058 81.3546 12.8274C126.623 6.08827 174.478 19.724 219.744 52.2594C254.743 77.4191 301.126 90.9672 361.545 93.6779L362.403 93.7228C379.222 94.689 395.491 101.623 409.453 113.777C423.234 125.772 433.581 141.776 439.376 160.059C440.089 162.288 440.742 164.609 441.317 166.955C441.853 169.136 441.815 171.419 441.207 173.581C440.6 175.743 439.443 177.711 437.849 179.293V179.297L437.698 179.452C437.336 179.812 436.955 180.158 436.565 180.479L436.107 180.857C432.246 184.037 429.197 186.55 425.547 188.501C423.112 189.794 420.523 190.772 417.842 191.41C403.119 195 388.167 198.328 373.402 201.302C344.728 207.084 315.298 211.853 285.93 215.478C239.889 221.155 193.544 224.001 147.154 224ZM79.0813 14.2096C78.9912 14.2088 78.901 14.2149 78.8118 14.2279C49.7342 18.9344 25.4112 37.4652 12.0817 65.0684C9.00316 71.4765 6.56047 78.171 4.78865 85.0559C-0.271609 105.158 -0.432865 126.181 4.31844 146.358C6.86323 157.432 11.0974 168.049 16.8722 177.836C25.511 192.271 36.8317 203.647 49.6107 210.733C67.9062 220.88 87.6748 221.59 106.793 222.277C166.586 224.413 226.455 221.807 285.838 214.484C315.186 210.862 344.597 206.096 373.252 200.318C388.007 197.345 402.949 194.02 417.662 190.432C420.279 189.81 422.805 188.856 425.181 187.595C428.757 185.683 431.778 183.194 435.602 180.044L436.06 179.667C436.395 179.39 436.724 179.094 437.039 178.787L437.129 178.692C440.272 175.525 441.494 171.346 440.482 167.227V167.227C439.913 164.905 439.266 162.61 438.561 160.403C426.724 123.054 396.101 96.6589 362.361 94.7212L361.508 94.6763C333.909 93.4378 309.759 90.0073 287.679 84.1877C261.32 77.241 238.309 66.7837 219.284 53.107C174.191 20.6963 126.536 7.11131 81.4651 13.8185C81.0441 13.8911 80.6299 13.9985 80.2266 14.1396L79.9153 14.2267C79.7385 14.2346 79.5613 14.2325 79.3848 14.2204C79.2807 14.215 79.1799 14.2096 79.0813 14.2096Z"
                      fill="#B3B2B2"
                    />
                    <path
                      d="M139.575 72.9821C138.327 71.7845 137.05 65.1063 135.457 64.4283C136.648 67.0609 135.783 67.7579 135.777 70.6472C135.792 72.2878 135.6 73.9238 135.206 75.5165H108.211V54.4489C108.211 52.5559 108.584 50.6814 109.309 48.9326C110.033 47.1837 111.095 45.5946 112.433 44.256C113.772 42.9175 115.361 41.8557 117.11 41.1313C118.859 40.4069 120.733 40.0341 122.626 40.0342C123.349 40.0483 124.066 40.1534 124.763 40.347C127.083 40.9734 129.198 42.199 130.895 43.9008C132.592 45.6026 133.812 47.7208 134.432 50.0428C136.49 57.5648 139.763 70.0859 139.575 72.9821Z"
                      fill="#2F2E41"
                    />
                    <path
                      d="M109.796 98.899L109.809 82.478L100.156 83.3406L103.563 93.6973L101.968 119.729C101.195 119.903 100.489 120.297 99.9363 120.865C99.3835 121.433 99.0079 122.15 98.8553 122.927C98.7026 123.705 98.7795 124.51 99.0767 125.245C99.3738 125.98 99.8782 126.612 100.529 127.065C101.179 127.518 101.947 127.772 102.739 127.796C103.531 127.82 104.313 127.613 104.99 127.2C105.666 126.787 106.208 126.187 106.549 125.471C106.89 124.756 107.016 123.957 106.91 123.171L109.796 98.899Z"
                      fill="#FFB6B6"
                    />
                    <path
                      d="M128.792 216.244L132.692 216.243L134.547 201.202H128.791L128.792 216.244Z"
                      fill="#FFB6B6"
                    />
                    <path
                      d="M127.471 214.32L133.636 213.952V216.593L139.497 220.641C139.786 220.841 140.004 221.128 140.119 221.461C140.234 221.793 140.239 222.154 140.134 222.49C140.03 222.826 139.82 223.119 139.537 223.328C139.254 223.536 138.911 223.649 138.559 223.649H131.22L129.955 221.036L129.461 223.649H126.694L127.471 214.32Z"
                      fill="#2F2E41"
                    />
                    <path
                      d="M106.243 216.244L110.143 216.243L111.998 201.202H106.243L106.243 216.244Z"
                      fill="#FFB6B6"
                    />
                    <path
                      d="M104.923 214.32L111.087 213.952V216.593L116.948 220.641C117.238 220.841 117.456 221.128 117.571 221.461C117.685 221.793 117.691 222.154 117.586 222.49C117.481 222.826 117.272 223.119 116.989 223.328C116.705 223.536 116.363 223.649 116.011 223.649H108.672L107.407 221.036L106.913 223.649H104.146L104.923 214.32Z"
                      fill="#2F2E41"
                    />
                    <path
                      d="M125.319 64.7451L117.241 64.9035L111.538 70.9229L106.966 71.5934C104.898 71.8967 102.997 72.9007 101.58 74.4375C100.163 75.9743 99.3171 77.9508 99.1826 80.0366L99.9746 84.3871H104.727L107.476 100.528C106.407 103.252 106.334 105.402 108.528 106.247L115.34 119.077L135.457 110.048C136.477 108.295 136.804 106.533 135.761 104.82L137.199 80.1102H142.035C142.035 75.4888 140.472 71.5928 135.879 71.0785C134.055 70.8811 132.223 70.7763 130.388 70.7644L125.319 64.7451Z"
                      fill="#E6E6E6"
                    />
                    <path
                      d="M135.457 110.048C135.457 110.048 115.815 113.533 108.529 106.247C108.529 106.247 107.789 107.502 106.674 109.585C106.354 110.184 105.734 110.59 105.361 111.315C105.021 111.975 104.147 112.786 103.777 113.533C103.479 114.135 103.956 114.921 103.647 115.571C99.915 123.398 95.5553 134.439 96.49 141.729C97.0927 146.43 98.3376 157.37 99.6488 169.12C99.7512 170.038 98.9215 171.217 99.0244 172.142C99.1215 173.015 100.151 173.633 100.248 174.508C100.313 175.089 99.5938 175.681 99.6581 176.261C99.7286 176.897 100.583 177.521 100.653 178.155C102.449 194.379 104.093 209.526 104.093 209.526H113.281L115.014 174.932L113.598 162.321L116.924 136.818L121.518 161.054L122.109 174.694L126.963 210.159H135.457V175.827L136.091 174.043L135.457 171.756L136.091 169.291L135.457 166.607V110.048Z"
                      fill="#2F2E41"
                    />
                    <path
                      d="M127.798 60.0602C126.547 61.7225 124.767 62.9091 122.751 63.4246C120.735 63.94 118.604 63.7535 116.708 62.8959C114.812 62.0382 113.265 60.5605 112.321 58.7061C111.378 56.8517 111.093 54.7311 111.516 52.6937C111.938 50.6563 113.042 48.8235 114.645 47.4972C116.248 46.1708 118.255 45.43 120.336 45.3967C122.416 45.3634 124.446 46.0396 126.091 47.314C127.736 48.5884 128.898 50.3849 129.385 52.4078C129.411 52.5175 129.433 52.6267 129.455 52.74C129.712 54.0079 129.698 55.316 129.412 56.5779C129.127 57.8397 128.577 59.0267 127.798 60.0602Z"
                      fill="#FFB6B6"
                    />
                    <path
                      d="M125.89 54.8352C125.695 53.8603 125.204 52.9694 124.483 52.2849C124.554 53.2192 124.424 54.1579 124.103 55.038C121.694 55.2513 119.275 54.7721 117.13 53.6567C115.514 52.5606 113.458 52.6556 111.063 53.6567C111.063 52.4918 111.292 51.3382 111.738 50.2619C112.184 49.1856 112.837 48.2077 113.661 47.384C114.485 46.5602 115.462 45.9068 116.539 45.4611C117.615 45.0153 118.769 44.786 119.934 44.7861H121.518C123.87 44.7866 126.126 45.7213 127.79 47.3847C129.453 49.0482 130.388 51.3042 130.388 53.6567C128.926 54.1811 127.421 54.5755 125.89 54.8352Z"
                      fill="#2F2E41"
                    />
                    <path
                      d="M56.5889 167.894C70.6633 167.894 82.0729 156.485 82.0729 142.41C82.0729 128.336 70.6633 116.926 56.5889 116.926C42.5145 116.926 31.105 128.336 31.105 142.41C31.105 156.485 42.5145 167.894 56.5889 167.894Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M218.986 50.9679C233.061 50.9679 244.47 39.5583 244.47 25.4839C244.47 11.4096 233.061 0 218.986 0C204.912 0 193.502 11.4096 193.502 25.4839C193.502 39.5583 204.912 50.9679 218.986 50.9679Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M421.359 171.892C435.433 171.892 446.843 160.482 446.843 146.408C446.843 132.333 435.433 120.924 421.359 120.924C407.285 120.924 395.875 132.333 395.875 146.408C395.875 160.482 407.285 171.892 421.359 171.892Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M264.958 28.2629V86.0496C264.958 87.2499 264.484 88.4018 263.64 89.255C262.796 90.1082 261.649 90.5938 260.449 90.6063C260.432 90.6081 260.416 90.6087 260.399 90.6084H253.673C248.292 90.6084 243.131 88.4707 239.326 84.6655C235.521 80.8603 233.383 75.6993 233.383 70.3179V28.2629C233.383 27.0538 233.863 25.8943 234.718 25.0394C235.573 24.1844 236.733 23.7041 237.942 23.7041H240.667C239.404 27.3871 256.54 28.9377 257.48 23.7041H260.399C261.608 23.7041 262.768 24.1844 263.623 25.0394C264.477 25.8943 264.958 27.0539 264.958 28.2629Z"
                      fill="#F70D02"
                    />
                    <path
                      d="M244.999 19.3831C244.999 19.2247 245.062 19.0728 245.174 18.9608C245.286 18.8488 245.438 18.7858 245.596 18.7856H249.659C249.817 18.7861 249.969 18.8492 250.08 18.9612C250.192 19.0732 250.255 19.2249 250.255 19.3831C250.255 19.5412 250.192 19.693 250.08 19.8049C249.969 19.9169 249.817 19.9801 249.659 19.9805H245.596C245.438 19.9804 245.286 19.9174 245.174 19.8054C245.062 19.6934 244.999 19.5415 244.999 19.3831Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M261.795 97.9381H236.103C234.11 97.9359 232.199 97.1431 230.789 95.7336C229.38 94.3242 228.587 92.4132 228.585 90.4199V50.0247C228.444 49.9234 228.329 49.7899 228.249 49.6353C228.17 49.4807 228.129 49.3095 228.129 49.1358V45.0732C228.129 44.8996 228.17 44.7284 228.249 44.5738C228.329 44.4193 228.444 44.2859 228.585 44.1846V43.0942C228.444 42.993 228.329 42.8595 228.249 42.705C228.17 42.5505 228.129 42.3793 228.129 42.2056V38.1428C228.129 37.9691 228.17 37.7979 228.249 37.6434C228.329 37.4888 228.444 37.3554 228.585 37.2542V35.2835C228.41 35.1899 228.265 35.0508 228.164 34.881C228.062 34.7111 228.009 34.517 228.01 34.3192V30.2566C228.009 30.0589 228.062 29.8647 228.164 29.6948C228.265 29.5249 228.41 29.3857 228.585 29.2921V23.8922C228.587 21.8989 229.38 19.9879 230.789 18.5785C232.199 17.1691 234.11 16.3763 236.103 16.374H261.795C263.788 16.3763 265.699 17.1691 267.109 18.5785C268.518 19.988 269.311 21.899 269.313 23.8922V35.6629C269.448 35.7476 269.56 35.8653 269.638 36.005C269.715 36.1447 269.756 36.3017 269.756 36.4614V44.208C269.756 44.3678 269.715 44.5249 269.638 44.6646C269.56 44.8043 269.448 44.9221 269.313 45.0068V90.4199C269.311 92.4131 268.518 94.3241 267.109 95.7336C265.699 97.143 263.788 97.9358 261.795 97.9381ZM236.103 17.3734C234.375 17.3753 232.718 18.0628 231.496 19.2848C230.273 20.5069 229.586 22.1639 229.584 23.8922V30.1422L229.103 30.1607C229.078 30.1616 229.055 30.1721 229.037 30.1899C229.02 30.2078 229.01 30.2316 229.009 30.2566V34.3192C229.01 34.3442 229.02 34.368 229.037 34.3859C229.055 34.4037 229.078 34.4141 229.103 34.4151L229.584 34.4334V37.9558L229.204 38.0495C229.183 38.0546 229.164 38.0665 229.15 38.0834C229.137 38.1002 229.129 38.1211 229.129 38.1428V42.2056C229.129 42.2273 229.137 42.2481 229.15 42.265C229.164 42.2819 229.183 42.2937 229.204 42.2988L229.584 42.3925V44.8863L229.204 44.98C229.183 44.9851 229.164 44.997 229.15 45.0138C229.137 45.0307 229.129 45.0516 229.129 45.0732V49.1358C229.129 49.1575 229.137 49.1784 229.15 49.1953C229.164 49.2122 229.183 49.2242 229.204 49.2293L229.584 49.3229V90.4199C229.586 92.1482 230.273 93.8052 231.496 95.0273C232.718 96.2494 234.375 96.9368 236.103 96.9387H261.795C263.523 96.9367 265.18 96.2493 266.402 95.0272C267.624 93.8051 268.312 92.1482 268.314 90.4199V44.1512H268.756V36.5185H268.314V23.8922C268.312 22.1639 267.624 20.507 266.402 19.2849C265.18 18.0628 263.523 17.3754 261.795 17.3734L236.103 17.3734Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M251.929 19.9805C252.259 19.9805 252.527 19.7131 252.527 19.3831C252.527 19.0531 252.259 18.7856 251.929 18.7856C251.6 18.7856 251.332 19.0531 251.332 19.3831C251.332 19.7131 251.6 19.9805 251.929 19.9805Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M121.963 135.116H55.112C54.1626 135.114 53.2529 134.736 52.5815 134.064C51.9102 133.393 51.5319 132.483 51.5293 131.534V98.9601C51.5317 98.0108 51.9099 97.101 52.5812 96.4297C53.2524 95.7583 54.1622 95.38 55.1115 95.3774H121.963C122.912 95.3799 123.822 95.7581 124.493 96.4293C125.165 97.1006 125.543 98.0103 125.546 98.9597V131.534C125.543 132.483 125.165 133.393 124.494 134.064C123.823 134.735 122.913 135.114 121.963 135.116Z"
                      fill="white"
                    />
                    <path
                      d="M121.963 135.116H55.112C54.1626 135.114 53.2529 134.736 52.5815 134.064C51.9102 133.393 51.5319 132.483 51.5293 131.534V98.9601C51.5317 98.0108 51.9099 97.101 52.5812 96.4297C53.2524 95.7583 54.1622 95.38 55.1115 95.3774H121.963C122.912 95.3799 123.822 95.7581 124.493 96.4293C125.165 97.1006 125.543 98.0103 125.546 98.9597V131.534C125.543 132.483 125.165 133.393 124.494 134.064C123.823 134.735 122.913 135.114 121.963 135.116ZM55.112 96.3768C54.4274 96.3788 53.7714 96.6517 53.2874 97.1359C52.8033 97.62 52.5306 98.276 52.5287 98.9606V131.534C52.5306 132.218 52.8035 132.874 53.2877 133.358C53.7718 133.842 54.4279 134.115 55.1125 134.117H121.962C122.647 134.115 123.303 133.842 123.787 133.358C124.272 132.874 124.544 132.218 124.546 131.533V98.9602C124.544 98.2756 124.271 97.6196 123.787 97.1355C123.303 96.6515 122.647 96.3787 121.962 96.3768L55.112 96.3768Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M92.1205 130.302C78.9359 130.302 65.1881 130.176 60.0586 130.095C59.3837 130.081 58.741 129.804 58.2677 129.322C57.7944 128.841 57.528 128.194 57.5254 127.519V100.555C57.5257 100.313 57.6216 100.081 57.7923 99.9102C57.9631 99.739 58.1946 99.6425 58.4363 99.6416H118.636C118.878 99.6419 119.11 99.7379 119.281 99.9085C119.452 100.079 119.548 100.311 119.549 100.552V118.847C119.538 121.833 118.357 124.696 116.259 126.822C114.161 128.947 111.314 130.166 108.328 130.216C103.547 130.278 97.8864 130.302 92.1205 130.302Z"
                      fill="#F70D02"
                    />
                    <path
                      d="M115.063 117.166H60.6678C60.2124 117.165 59.7683 117.023 59.3961 116.761C59.0238 116.499 58.7414 116.128 58.5871 115.699L52.4304 98.427C52.3117 98.0939 52.2747 97.7372 52.3225 97.3868C52.3703 97.0364 52.5015 96.7026 52.7051 96.4134C52.9086 96.1243 53.1786 95.8882 53.4923 95.725C53.806 95.5618 54.1543 95.4762 54.5079 95.4755L122.501 95.3809C122.824 95.3805 123.144 95.4511 123.437 95.5875C123.73 95.724 123.989 95.9231 124.197 96.1707C124.405 96.4184 124.555 96.7086 124.639 97.0208C124.722 97.3331 124.736 97.6599 124.68 97.9781L124.732 98.0003L124.537 98.4558L124.535 98.4604L117.092 115.827C116.922 116.225 116.64 116.564 116.279 116.802C115.918 117.04 115.495 117.167 115.063 117.166ZM122.504 96.3802L54.5098 96.4749C54.3161 96.4752 54.1253 96.5221 53.9535 96.6114C53.7816 96.7008 53.6337 96.8301 53.5222 96.9885C53.4107 97.1469 53.3388 97.3298 53.3126 97.5217C53.2864 97.7136 53.3066 97.9091 53.3716 98.0915L59.5282 115.363C59.6128 115.598 59.7676 115.801 59.9716 115.945C60.1757 116.089 60.419 116.166 60.6686 116.167H115.063C115.3 116.167 115.531 116.098 115.729 115.967C115.926 115.837 116.081 115.651 116.173 115.434L123.616 98.0667C123.695 97.8826 123.727 97.6819 123.71 97.4825C123.692 97.2831 123.625 97.0912 123.514 96.924C123.404 96.7569 123.254 96.6197 123.078 96.5248C122.902 96.4299 122.705 96.3802 122.504 96.3802Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M88.4356 120.926C90.788 120.926 92.6949 119.019 92.6949 116.667C92.6949 114.314 90.788 112.407 88.4356 112.407C86.0832 112.407 84.1763 114.314 84.1763 116.667C84.1763 119.019 86.0832 120.926 88.4356 120.926Z"
                      fill="white"
                    />
                    <path
                      d="M249.335 83.9493C251.687 83.9493 253.594 82.0424 253.594 79.69C253.594 77.3376 251.687 75.4307 249.335 75.4307C246.982 75.4307 245.075 77.3376 245.075 79.69C245.075 82.0424 246.982 83.9493 249.335 83.9493Z"
                      fill="white"
                    />
                    <path
                      d="M410.431 141.471L399.053 130.238C398.499 129.687 397.842 129.25 397.119 128.954C396.396 128.657 395.622 128.506 394.841 128.509H394.801C394.014 128.511 393.235 128.67 392.509 128.975C391.783 129.28 391.125 129.726 390.573 130.288C388.029 132.862 386.582 136.323 386.537 139.942C386.491 143.561 387.85 147.057 390.329 149.695C390.448 149.825 390.573 149.95 390.698 150.075C391.39 150.763 392.154 151.375 392.977 151.899C395.226 153.352 397.849 154.121 400.527 154.113H400.612C402.45 154.106 404.269 153.736 405.963 153.022C407.657 152.309 409.192 151.266 410.481 149.955C411.597 148.823 412.219 147.293 412.21 145.703C412.2 144.112 411.561 142.59 410.431 141.471ZM409.771 149.251C407.659 151.379 404.877 152.714 401.896 153.03C398.914 153.347 395.914 152.626 393.402 150.99C392.683 150.514 392.012 149.97 391.398 149.366C388.946 146.944 387.557 143.648 387.535 140.203C387.514 136.757 388.862 133.444 391.283 130.992C391.743 130.523 392.292 130.151 392.898 129.896C393.503 129.641 394.154 129.509 394.811 129.508H394.841C395.491 129.506 396.136 129.632 396.738 129.879C397.34 130.126 397.887 130.489 398.349 130.947L409.726 142.185C410.668 143.117 411.202 144.384 411.21 145.709C411.219 147.033 410.701 148.307 409.771 149.251Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M373.099 104.604L361.721 93.3661C360.601 92.255 359.087 91.6333 357.509 91.6372H357.474C356.686 91.6404 355.906 91.7997 355.179 92.1058C354.453 92.412 353.794 92.859 353.242 93.4211C351.138 95.5571 349.775 98.3105 349.35 101.278C348.926 104.245 349.463 107.271 350.883 109.911L350.888 109.916C351.474 110.995 352.202 111.992 353.052 112.879C353.147 112.989 353.257 113.099 353.367 113.209C355.979 115.802 359.514 117.254 363.195 117.246H363.285C365.124 117.238 366.942 116.867 368.636 116.152C370.33 115.438 371.866 114.395 373.154 113.084C373.707 112.523 374.145 111.859 374.441 111.13C374.738 110.401 374.888 109.62 374.883 108.832C374.878 108.045 374.718 107.266 374.412 106.541C374.106 105.815 373.66 105.157 373.099 104.604ZM372.44 112.384C371.244 113.601 369.818 114.569 368.246 115.232C366.674 115.895 364.986 116.24 363.28 116.247H363.195C360.633 116.246 358.128 115.487 355.996 114.066C353.864 112.646 352.199 110.626 351.212 108.262C350.225 105.898 349.958 103.294 350.446 100.779C350.935 98.2635 352.156 95.9488 353.956 94.1257C354.888 93.1838 356.155 92.6501 357.48 92.6417C358.804 92.6333 360.078 93.1508 361.022 94.0807L372.4 105.314C373.341 106.247 373.874 107.515 373.881 108.841C373.889 110.166 373.37 111.44 372.44 112.384Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M411.158 145.003L398.615 132.614C397.792 131.803 396.682 131.352 395.527 131.359C394.372 131.366 393.267 131.831 392.455 132.652C391.438 133.679 390.634 134.895 390.089 136.233C389.543 137.571 389.266 139.003 389.275 140.447C389.283 141.892 389.576 143.321 390.136 144.652C390.697 145.984 391.515 147.192 392.543 148.207C393.57 149.222 394.788 150.025 396.127 150.569C397.465 151.113 398.897 151.388 400.342 151.378C401.786 151.368 403.215 151.074 404.546 150.512C405.877 149.95 407.083 149.131 408.097 148.102L411.158 145.003Z"
                      fill="#F70D02"
                    />
                    <path
                      d="M373.829 108.133L361.285 95.7444C360.463 94.9339 359.352 94.4827 358.198 94.4898C357.043 94.497 355.938 94.9619 355.126 95.7827C354.109 96.8094 353.305 98.0264 352.76 99.364C352.214 100.702 351.937 102.134 351.945 103.578C351.954 105.023 352.246 106.452 352.807 107.783C353.368 109.115 354.186 110.322 355.214 111.338C356.241 112.353 357.459 113.155 358.797 113.7C360.136 114.244 361.568 114.519 363.013 114.509C364.457 114.499 365.886 114.205 367.217 113.643C368.547 113.08 369.754 112.261 370.768 111.232L373.829 108.133Z"
                      fill="#F70D02"
                    />
                    <path
                      d="M397.374 152.719L397.074 153.508C395.665 152.974 394.299 152.437 392.977 151.899C369.552 142.34 358.369 131.152 350.888 109.916L350.883 109.911C350.529 108.911 350.184 107.889 349.849 106.843L350.639 106.588C350.903 107.594 351.289 108.564 351.788 109.476C352.198 110.64 352.619 111.775 353.052 112.879C360.083 130.803 370.451 141.046 390.329 149.696C391.328 150.13 392.352 150.562 393.402 150.99C394.62 151.784 395.963 152.368 397.374 152.719Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M361.513 116.337L360.811 117.048L386.764 142.681L387.466 141.969L361.513 116.337Z"
                      fill="#3F3D56"
                    />
                    <path
                      d="M141.793 95.0973L141.806 78.6763L132.154 79.5389L135.56 89.8955L123.194 108.641C122.421 108.814 121.715 109.209 121.162 109.777C120.61 110.345 120.234 111.061 120.081 111.839C119.929 112.617 120.006 113.422 120.303 114.157C120.6 114.891 121.104 115.524 121.755 115.977C122.405 116.43 123.173 116.683 123.965 116.707C124.757 116.731 125.539 116.524 126.216 116.112C126.892 115.699 127.434 115.098 127.775 114.383C128.116 113.668 128.242 112.868 128.136 112.083L141.793 95.0973Z"
                      fill="#FFB6B6"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1204_6087">
                      <rect width="446.843" height="224" fill="white" />
                    </clipPath>
                  </defs>
                </svg> */}
                <img src={contactimg}/>
              </div>
              <div className="contact-info text-center pt-3">
                <p className="text-danger">
                  For any query contact to below number
                </p>
                <h4>{websiteLinks.number}</h4>
                <p className="text-danger">OR</p>
                <p className="text-danger">Reach at our Email</p>
                <h4>{websiteLinks.email}</h4>
              </div>
            </div>
            <div className="contact-form col-8 m-auto">
              <form onSubmit={handleSubmit}>
                <div className="col-12 d-flex flex-wrap">
                  {/* name */}
                  <div className="col-6 ps-3 pe-3 form-group">
                    <input
                      className="form-input"
                      type="text"
                      id="name"
                      name="name"
                      value={contactFormData.name}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="Your Name"
                    />
                    {formErrors.name && (
                      <span className="text-danger formerror">
                        {formErrors.name}
                      </span>
                    )}
                  </div>
                  {/* email */}
                  <div className="col-6 ps-3 pe-3 form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={contactFormData.email}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="Your Email"
                      className="form-input"
                    />
                    {formErrors.email && (
                      <span className="text-danger formerror">
                        {formErrors.email}
                      </span>
                    )}
                  </div>
                  {/* number */}
                  <div className="col-6 ps-3 pe-3 form-group">
                    <input
                      type="tel"
                      id="number"
                      name="number"
                      value={contactFormData.number}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="Your Number"
                      className="form-input"
                    />
                    {formErrors.number && (
                      <span className="text-danger formerror">
                        {formErrors.number}
                      </span>
                    )}
                  </div>
                  {/* subject */}
                  <div className="col-6 ps-3 pe-3 form-group">
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={contactFormData.subject}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="Subject"
                      className="form-input"
                    />
                    {formErrors.subject && (
                      <span className="text-danger formerror">
                        {formErrors.subject}
                      </span>
                    )}
                  </div>
                  {/* message */}
                  <div className="col-12 ps-3 pe-3 form-group">
                    <textarea
                      id="message"
                      name="message"
                      value={contactFormData.message}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="Message"
                      className="form-input"
                    />
                    {formErrors.message && (
                      <span className="text-danger formerror">
                        {formErrors.message}
                      </span>
                    )}
                  </div>

                  <div className="col-12 ps-3 pe-3 form-group">
                    <LoadCanvasTemplate />
                    <input
                      ref={captchaRef1}
                      type="text"
                      className="form-input mt-2"
                      value={captcha}
                      onChange={handlecaptcha}
                      placeholder="Enter Captcha"
                    />

                    {errorcaptcha && (
                      <span className="text-danger formerror">
                        {errorcaptcha}
                      </span>
                    )}
                  </div>
                </div>
                {/* button */}
                <div className="submit text-center">
                  <button
                    type="submit"
                    className="btn-submit"
                    onClick={handleCaptcha1}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </Col>
        </Container>
      </Container>
    </>
  );
};
export default ContactUs;
